import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ValidationProfiler } from "validation";

@Injectable()
export class ValidationProfilerImpl implements ValidationProfiler {
    getExecDurationSubj(): Subject<number> | null {
        return null;
    }
}
